import React from 'react';

import styles from './skill.module.css';
import Icon from './Icon';

const SkillCat = ({skills, title}) => {

  return (
    <div className={styles.skillCatWrapper}>

      <div className={styles.skillCatTitle}>
        {title}
      </div>

      <div className={styles.skillCatItems}>


        {
          skills.map( icon => (
            <div className={styles.skillCatItem}>


              <div className={styles.skillCatIcon}>
                <Icon type={`${icon[0]}`} />
              </div>

            <div className={styles.skillCatHeader}>

              <div
                className={styles.skillCatBar}
                style={{width: `${icon[1]*10}%`}}
              ></div>



              <div className={styles.axisWrapper}>
                <div className={styles.axis}>
                  <div className={styles.axisMin}>
                    proficient
                  </div>
                  <div className={styles.axisMax}>
                    expert
                  </div>
                </div>
              </div>

            </div>


            </div>
          ))
        }

      </div>

    </div>
  )
}

export default SkillCat;